<template>
  <div class="flex center-xs space-bottom-1 space-top-1">
    <div class="flex vertical-center align-center">
      <div>
          <input v-if="inputValid" @click="$emit('progress')" class="form-button" type="button" :value="buttonText">
          <input v-else class="form-button" type="button" :value="buttonText" disabled>
      </div>
      <div v-if="order !== 'first'">
        <input @click="$emit('back')" class="back-button" type="button" :value="backButtonText">
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    props: ['inputValid', 'order', 'buttonText'],
    computed: {
        ...mapState([
            'backButtonText'
        ])
    }
}
</script>

<style lang="scss" scoped>
  input[type=button].form-button {
    text-transform: uppercase;
    font-size: 13px;
    line-height: 15px;
    width: 200px;
    height: 48px;
    background: #0384FB;
    border-radius: 3px;
    border: none;
    &:hover {
        background: #0384FB;
        border-radius: 3px;
    }
    &:disabled {
      background: #BCBCBC;
    }
  }
  input[type=button].back-button {
      margin-top: 35px;
      padding: 0px;
      background: #fff;
      border: none;
      border-bottom: 2px solid;
      border-radius: 0;
      color: #BCBCBC;
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 26px;
      &:hover {
          box-shadow: none;
      }
  }
</style>